import {
  inject,
  observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import {
  IFacilityFormStore,
} from '../../mobx-store/storeInterfaces/facilityFormInterface';

interface IProps extends WithSnackbarProps {
  facilityFormStore: IFacilityFormStore;
  countryStore: CountryStore;
  history: any;
}

interface IState {
  open: boolean;
}

@inject('facilityFormStore')
@inject('countryStore')
@observer
class FacilityForm extends Component<IProps, IState> {
  addButton: any;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  handleAgree: () => void = () => null;

  constructor(props: IProps) {
    super(props);
    this.title = translate('facilitiesFormsListPageTitle', {
    });
    this.state = {
      open: false,
    };
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/facilities-form/${this.props.facilityFormStore.facilityForms[index].questionsFormId}/edit`);
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleAdd = (): void => {
    this.props.history.push('/facilities-form/new');
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  getAddFacilityFormsButton = () => ({
    title: translate('facilitiesAreasListAddButton', {
    }),
    onAdd: this.handleAdd,
  });

  getFacilitiesFormsTableHeader = () => [
    {
      title: translate('facilitiesAreasListTitleColumnTitle', {
      }),
    },
    {
      title: translate('facilitiesAreasListEditColumnTitle', {
      }),
    },
  ];

  getFacilitiesFormsTableData = () => this.props.facilityFormStore.facilityForms
    .map((form) => ({
      ...form,
      edit: 'Edit',
    }));

  getFacilityFormsTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  returnTableData = () => {
    this.addButton = this.getAddFacilityFormsButton();
    this.tableHeader = this.getFacilitiesFormsTableHeader();
    this.tableData = this.getFacilitiesFormsTableData();
    this.tableCellTypes = this.getFacilityFormsTableCellTypes();
  };

  render() {
    this.returnTableData();
    return (
      <GeneralTableComponent
        emptyMessage={translate('facilitiesAreasListNoCategoriesMessage', {
        })}
        title={this.title}
        tableHeader={this.tableHeader}
        tableData={this.tableData}
        tableCellTypes={this.tableCellTypes}
        // addButton={this.addButton}
        loadingStatus={[
          this.props.facilityFormStore.getFacilitiesFormsRequestStatus,
          this.props.countryStore.getManagedCountriesRequestStatus
        ]}
      />
    );
  }

  async componentDidMount() {
    const {
      countryStore,
      facilityFormStore,
    } = this.props;
    await countryStore.getUserManagedCountries();
    facilityFormStore.getAll(countryStore.managedCountries);
  }
}

export default FacilityForm ;
